import _ from 'underscore';
import ko from 'knockout';
import { Validation } from '@bingads-webui/validation';
import * as putil from '@bingads-webui-universal/primitive-utilities';

const { getLength } = Validation.string;

/**
 * extend property for string property
 * @param {Observable} local - the observable to be extended
 * @param {Object} prop - property define
 * @param {I18n} i18n - get error message for rules
 * @returns {undefined} - extend local with new property, no return
 */
export function StringExtension(local, prop, i18n) {
  _.extend(local, {
    maxLength: ko.observable(prop.maxLength),
    cjkMaxLength: ko.observable(prop.cjkMaxLength),
  });

  _.extend(local, {
    remaining: ko.computed(() => {
      if (!_.isFinite(prop.maxLength)) {
        return Number.POSITIVE_INFINITY;
      }

      return local.maxLength() - getLength(local(), prop.distinguishCJK);
    }),
  });

  _.extend(local, {
    cjkRemaining: ko.computed(() => {
      if (!_.isFinite(prop.cjkMaxLength)) {
        return local.remaining();
      }

      return local.cjkMaxLength() - getLength(local(), prop.distinguishCJK);
    }),
  });

  _.extend(local, {
    strRemaining: ko.computed(() => {
      const remaining = local[putil.hasCJK(local()) ? 'cjkRemaining' : 'remaining']();

      if (!_.isFinite(remaining)) {
        return '';
      }

      return remaining >= 0 ?
        i18n.getString('KoSchema_String_RemainingCharactersText', { count: remaining }) :
        i18n.getString('KoSchema_String_ExceededCharactersText', { count: 0 - remaining });
    }),
  });
}
